module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-Regular.caebf1cf.eot";